<template>
  <div>
    <vs-table class="border-0 border-solid border-t border-silver-gray" ref="table"
      :max-items="tableData.vehicles.length" v-if="tableData.vehicles && tableData.vehicles.length"
      :data="tableData.vehicles || []">
      <template slot="thead">
        <vs-th v-for="(header, idx) in headers" :key="idx" class="text-black font-semibold text-sm">
          {{ header }}
        </vs-th>
      </template>
      <template v-if="tableData.vehicles && tableData.vehicles.length">
        <tbody @click="changeModalOpen">
          <vs-tr v-for="(tr, indextr) in tableData.vehicles" :key="indextr"
            :class="[indextr % 2 === 0 ? 'bg-soft-gray' : '']">
            <vs-td>
              {{ indextr + 1 }}
            </vs-td>
            <vs-td>
              {{ tr.name }}
            </vs-td>
            <vs-td>
              {{ tr.vehicle }}
            </vs-td>
            <vs-td>
              {{ tr.odometer_change }}
            </vs-td>
            <vs-td>
              {{ tr.driving_time }}
            </vs-td>
            <vs-td>
              {{ tr.start_odometer }}
            </vs-td>
            <vs-td>
              {{ tr.end_odometer }}
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data() {
    return {
      headers: ['#', 'Name', 'Vehicle', 'Odometer change', 'Driving time', 'Start odometer', 'End odometer'],
    }
  },
  methods: {
    changeModalOpen() {
      this.$emit('open');
    },
  }
};
</script>

<style scoped></style>
